module.exports = __webpack_public_path__ + "static/media/YM51_0.871e7f04.jpg";